import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, EventEmitter, Directive, Input, Output, HostListener, Component, ChangeDetectionStrategy, ViewChild, NgModule } from '@angular/core';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Subscription, Subject, merge } from 'rxjs';
import * as i3$1 from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerI18n, NgbDateParserFormatter, NgbDatepickerModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';

const ERROR_MESSAGES = new InjectionToken('ERROR_MESSAGES');

class SuraFormService {
    constructor(errorMessages) {
        this.errorMessages = errorMessages;
    }
    getErrorMessage(key) {
        const findErrorMessage = this.errorMessages.find(errorMessage => {
            return errorMessage.key === key.toUpperCase();
        });
        return findErrorMessage
            ? findErrorMessage.errorMessage
            : SuraFormService.DEFAULT_MESSAGE;
    }
}
SuraFormService.DEFAULT_MESSAGE = 'Campo inválido';
SuraFormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormService, deps: [{ token: ERROR_MESSAGES }], target: i0.ɵɵFactoryTarget.Injectable });
SuraFormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ERROR_MESSAGES]
                }] }]; } });

var InputProperty;
(function (InputProperty) {
    InputProperty["ID"] = "id";
})(InputProperty || (InputProperty = {}));

class BaseInput {
    constructor() {
        this.handleChange = new EventEmitter();
        this.handleBlur = new EventEmitter();
        this.handleKeyDown = new EventEmitter();
        this.handleKeyUp = new EventEmitter();
        this.subscription = new Subscription();
    }
    ngOnInit() {
        this.componentValidatorService.checkRequiredFields(this.id, InputProperty.ID);
        this.subscribeToMarkForCheck();
    }
    subscribeToMarkForCheck() {
        this.subscription.add(this.control.valueChanges.subscribe(() => {
            this.changeDetectorRef.markForCheck();
        }));
    }
    onChange(event) {
        this.handleChange.emit(event.target.value);
    }
    onBlur(event) {
        this.handleBlur.emit(event.target.value);
    }
    showErrorMessage(key) {
        return this.suraFormService.getErrorMessage(Object.keys(key)[0]);
    }
    checkControl() {
        return this.componentValidatorService.wasValidate(this.control, this.wasValidate);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
BaseInput.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BaseInput, deps: [], target: i0.ɵɵFactoryTarget.Directive });
BaseInput.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: BaseInput, inputs: { control: "control", wasValidate: "wasValidate", id: "id", textTransform: "textTransform", disabled: "disabled", alignCenter: "alignCenter" }, outputs: { handleChange: "handleChange", handleBlur: "handleBlur", handleKeyDown: "handleKeyDown", handleKeyUp: "handleKeyUp" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: BaseInput, decorators: [{
            type: Directive
        }], propDecorators: { control: [{
                type: Input
            }], wasValidate: [{
                type: Input
            }], id: [{
                type: Input
            }], textTransform: [{
                type: Input
            }], disabled: [{
                type: Input
            }], alignCenter: [{
                type: Input
            }], handleChange: [{
                type: Output
            }], handleBlur: [{
                type: Output
            }], handleKeyDown: [{
                type: Output
            }], handleKeyUp: [{
                type: Output
            }] } });

class ComponentValidatorService {
    checkRequiredFields(input, error) {
        if (!input) {
            throw new Error(`Attribute ${error} is required`);
        }
    }
    wasValidate(control, wasValidate) {
        return ((!control.valid && control.touched && !control.disabled) ||
            (control.untouched && wasValidate && !control.disabled));
    }
}
ComponentValidatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ComponentValidatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ComponentValidatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ComponentValidatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ComponentValidatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class TolowercaseDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    onInputChange() {
        if (this.elementTolowercase) {
            this.elementRef.nativeElement.value = this.elementRef.nativeElement.value.toLowerCase();
        }
    }
}
TolowercaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TolowercaseDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TolowercaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TolowercaseDirective, selector: "[libTolowercase]", inputs: { elementTolowercase: ["libTolowercase", "elementTolowercase"] }, host: { listeners: { "input": "onInputChange()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TolowercaseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[libTolowercase]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { elementTolowercase: [{
                type: Input,
                args: ['libTolowercase']
            }], onInputChange: [{
                type: HostListener,
                args: ['input']
            }] } });

// Angular Core
class DisableCopyPasteDirective {
    constructor() { }
    blockPaste(e) {
        if (this.appDisableCopyPaste) {
            e.preventDefault();
        }
    }
    blockCopy(e) {
        if (this.appDisableCopyPaste) {
            e.preventDefault();
        }
    }
    blockCut(e) {
        if (this.appDisableCopyPaste) {
            e.preventDefault();
        }
    }
}
DisableCopyPasteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DisableCopyPasteDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
DisableCopyPasteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: DisableCopyPasteDirective, selector: "[appDisableCopyPaste]", inputs: { appDisableCopyPaste: "appDisableCopyPaste" }, host: { listeners: { "paste": "blockPaste($event)", "copy": "blockCopy($event)", "cut": "blockCut($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DisableCopyPasteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appDisableCopyPaste]',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { appDisableCopyPaste: [{
                type: Input,
                args: ['appDisableCopyPaste']
            }], blockPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }], blockCopy: [{
                type: HostListener,
                args: ['copy', ['$event']]
            }], blockCut: [{
                type: HostListener,
                args: ['cut', ['$event']]
            }] } });

class LimitNumberDirective {
    handleKeyboardEvent(event) {
        if (this.appLimitNumberDirective) {
            const limitTo = this.appLimitNumberDirective;
            if (limitTo * 1 === event.target.value.length) {
                event.preventDefault();
            }
        }
    }
}
LimitNumberDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumberDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
LimitNumberDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: { appLimitNumberDirective: "appLimitNumberDirective" }, host: { listeners: { "keypress": "handleKeyboardEvent($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumberDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appLimitNumberDirective]',
                }]
        }], propDecorators: { appLimitNumberDirective: [{
                type: Input
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }] } });

class LibInputMaterialDesignComponent extends BaseInput {
    constructor(suraFormService, componentValidatorService, changeDetectorRef) {
        super();
        this.suraFormService = suraFormService;
        this.componentValidatorService = componentValidatorService;
        this.changeDetectorRef = changeDetectorRef;
        this.inputType = 'text';
        this.handleChange = new EventEmitter();
    }
    handleOnKeyDown(event) {
        if (this.inputType === 'number' && event.key === 'e') {
            event.preventDefault();
        }
        this.handleKeyDown.emit(event.target.value);
    }
    handleOnKeyUp(event) {
        this.handleKeyUp.emit(event.target.value);
    }
}
LibInputMaterialDesignComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibInputMaterialDesignComponent, deps: [{ token: SuraFormService }, { token: ComponentValidatorService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LibInputMaterialDesignComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibInputMaterialDesignComponent, selector: "lib-input-material-design", inputs: { label: "label", maxlength: "maxlength", minlength: "minlength", inputType: "inputType", enableCopyPaste: "enableCopyPaste", enableTolowercase: "enableTolowercase", numberMaxlength: "numberMaxlength" }, outputs: { handleChange: "handleChange" }, usesInheritance: true, ngImport: i0, template: "<div class=\"mb-3 position-relative\" [class.was-validate]=\"checkControl()\">\n  <div\n    class=\"d-flex align-items-center form-material position-relative\"\n    [class.justify-content-center]=\"alignCenter\"\n  >\n    <ng-content select=\"[slot=inputRef]\"></ng-content>\n    <input\n      [formControl]=\"control\"\n      [type]=\"inputType\"\n      class=\"py-2 px-3 form-material__input\"\n      [class.ng-not-empty]=\"control.value\"\n      autocomplete=\"off\"\n      [minlength]=\"minlength\"\n      [maxlength]=\"maxlength\"\n      [id]=\"id\"\n      (blur)=\"onBlur($event)\"\n      (change)=\"onChange($event)\"\n      [libTolowercase]=\"enableTolowercase\"\n      [style.text-transform]=\"textTransform\"\n      [appDisableCopyPaste]=\"enableCopyPaste\"\n      [appLimitNumberDirective]=\"numberMaxlength\"\n      (keydown)=\"handleOnKeyDown($event)\"\n      (keyup)=\"handleOnKeyUp($event)\"\n    />\n    <label class=\"mx-2 px-2 mb-0 form-material__label\" *ngIf=\"label\">{{\n      label\n    }}</label>\n    <i\n      class=\"fal fa-check form-material__icon-state form-material__icon-state_success\"\n    ></i>\n    <i\n      class=\"fal fa-times form-material__icon-state form-material__icon-state_error\"\n    ></i>\n  </div>\n  <div\n    class=\"invalid-message\"\n    [class.text-center]=\"alignCenter\"\n    *ngIf=\"control.errors\"\n  >\n    {{ showErrorMessage(control.errors) }}\n  </div>\n</div>\n", styles: ["", ".form-material{margin-bottom:1.7rem}.form-material__input{width:100%;background:#fff;border:.0625rem solid var(--form-material-input-border-color, #d2d2d2);outline:none;color:#000;font-size:1rem;border-radius:.25rem;font-family:var(--font-family-form-material, var(--font-family-secondary));box-shadow:none;-webkit-appearance:none;-moz-appearance:none}.form-material__input:focus~.form-material__label,.form-material__input.ng-not-empty~.form-material__label{transform:translateY(-1.375rem);font-size:.8125rem}.form-material__input.ng-valid.ng-not-empty{border-color:var(--color-input-valid)!important;color:var(--form-material-text-color-valid, #000)}.form-material__input.ng-valid.ng-not-empty~.form-material__label{color:var(--form-material-valid-label-color, var(--color-input-valid))!important}.form-material__input.ng-valid.ng-not-empty~.form-material__arrow{border-top-color:var(--color-input-valid)}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_success{opacity:1}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_error{opacity:0!important}.form-material__input::-ms-clear{display:none}.form-material__input::-webkit-outer-spin-button,.form-material__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.form-material__arrow{position:absolute;right:.9375rem;pointer-events:none;border-left:.3125rem solid transparent;border-right:.3125rem solid transparent;border-top:.375rem solid #727272}.form-material__label{font-family:var(--font-family-form-label, var(--font-family-secondary));transition:all .15s ease-in-out;font-size:1rem;position:absolute;pointer-events:none;color:var(--form-material-label-color, #999999);background:#fff}.form-material__icon-state{position:absolute;right:.9375rem;font-size:1.375rem;pointer-events:none;opacity:0}.form-material__icon-state_success{color:var(--form-material-color-icon-success, #00aec7)}.form-material__icon-state_error{color:#ff585d}.was-validate .form-material__input{border-color:#e4002b}.was-validate .form-material__label{color:#ff585d}.was-validate .form-material__icon-state_error{opacity:1}.was-validate .form-material__arrow{border-top-color:#ff585d}.was-validate .invalid-message{display:block;text-align:left}.invalid-message{font-weight:100!important;position:absolute;width:100%;margin-top:.25rem;min-height:1.2rem;color:#ff585d;bottom:-1.1rem;font-size:.8rem;display:none}\n"], directives: [{ type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i3.MinLengthValidator, selector: "[minlength][formControlName],[minlength][formControl],[minlength][ngModel]", inputs: ["minlength"] }, { type: i3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: TolowercaseDirective, selector: "[libTolowercase]", inputs: ["libTolowercase"] }, { type: DisableCopyPasteDirective, selector: "[appDisableCopyPaste]", inputs: ["appDisableCopyPaste"] }, { type: LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: ["appLimitNumberDirective"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibInputMaterialDesignComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-input-material-design',
                    templateUrl: './lib-input-material-design.component.html',
                    styleUrls: [
                        './lib-input-material-design.component.scss',
                        '../../styles/_input.scss',
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: SuraFormService }, { type: ComponentValidatorService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], minlength: [{
                type: Input
            }], inputType: [{
                type: Input
            }], enableCopyPaste: [{
                type: Input
            }], enableTolowercase: [{
                type: Input
            }], numberMaxlength: [{
                type: Input
            }], handleChange: [{
                type: Output
            }] } });

class LibInputSelectMaterialDesignComponent extends BaseInput {
    constructor(suraFormService, componentValidatorService, changeDetectorRef) {
        super();
        this.suraFormService = suraFormService;
        this.componentValidatorService = componentValidatorService;
        this.changeDetectorRef = changeDetectorRef;
        this.label = 'Seleccione una opción';
        this.keyValue = 'value';
        this.keyLabel = 'name';
    }
}
LibInputSelectMaterialDesignComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibInputSelectMaterialDesignComponent, deps: [{ token: SuraFormService }, { token: ComponentValidatorService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LibInputSelectMaterialDesignComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibInputSelectMaterialDesignComponent, selector: "lib-input-select-material-design", inputs: { items: "items", label: "label", keyValue: "keyValue", keyLabel: "keyLabel" }, usesInheritance: true, ngImport: i0, template: "<div class=\"mb-3 position-relative\" [class.was-validate]=\"checkControl()\">\n  <div class=\"d-flex align-items-center form-material position-relative\">\n    <select\n      class=\"py-2 px-3 w-100 form-material__input\"\n      [formControl]=\"control\"\n      [class.ng-not-empty]=\"control.value\"\n      [id]=\"id\"\n      (change)=\"onChange($event)\"\n    >\n      <option value=\"\">{{ label }}</option>\n      <option *ngFor=\"let item of items\" value=\"{{ item[keyValue] }}\">\n        {{ item[keyLabel] }}\n      </option>\n    </select>\n    <label class=\"mx-2 px-2 mb-0 form-material__label\">{{ label }}</label>\n    <i class=\"form-material__arrow\"></i>\n  </div>\n  <div class=\"invalid-message\" *ngIf=\"control.errors\">\n    {{ showErrorMessage(control.errors) }}\n  </div>\n</div>\n", styles: ["", ".form-material{margin-bottom:1.7rem}.form-material__input{width:100%;background:#fff;border:.0625rem solid var(--form-material-input-border-color, #d2d2d2);outline:none;color:#000;font-size:1rem;border-radius:.25rem;font-family:var(--font-family-form-material, var(--font-family-secondary));box-shadow:none;-webkit-appearance:none;-moz-appearance:none}.form-material__input:focus~.form-material__label,.form-material__input.ng-not-empty~.form-material__label{transform:translateY(-1.375rem);font-size:.8125rem}.form-material__input.ng-valid.ng-not-empty{border-color:var(--color-input-valid)!important;color:var(--form-material-text-color-valid, #000)}.form-material__input.ng-valid.ng-not-empty~.form-material__label{color:var(--form-material-valid-label-color, var(--color-input-valid))!important}.form-material__input.ng-valid.ng-not-empty~.form-material__arrow{border-top-color:var(--color-input-valid)}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_success{opacity:1}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_error{opacity:0!important}.form-material__input::-ms-clear{display:none}.form-material__input::-webkit-outer-spin-button,.form-material__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.form-material__arrow{position:absolute;right:.9375rem;pointer-events:none;border-left:.3125rem solid transparent;border-right:.3125rem solid transparent;border-top:.375rem solid #727272}.form-material__label{font-family:var(--font-family-form-label, var(--font-family-secondary));transition:all .15s ease-in-out;font-size:1rem;position:absolute;pointer-events:none;color:var(--form-material-label-color, #999999);background:#fff}.form-material__icon-state{position:absolute;right:.9375rem;font-size:1.375rem;pointer-events:none;opacity:0}.form-material__icon-state_success{color:var(--form-material-color-icon-success, #00aec7)}.form-material__icon-state_error{color:#ff585d}.was-validate .form-material__input{border-color:#e4002b}.was-validate .form-material__label{color:#ff585d}.was-validate .form-material__icon-state_error{opacity:1}.was-validate .form-material__arrow{border-top-color:#ff585d}.was-validate .invalid-message{display:block;text-align:left}.invalid-message{font-weight:100!important;position:absolute;width:100%;margin-top:.25rem;min-height:1.2rem;color:#ff585d;bottom:-1.1rem;font-size:.8rem;display:none}\n"], directives: [{ type: i3.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i3.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i4.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibInputSelectMaterialDesignComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-input-select-material-design',
                    templateUrl: './lib-input-select-material-design.component.html',
                    styleUrls: [
                        './lib-input-select-material-design.component.scss',
                        '../../styles/_input.scss',
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: SuraFormService }, { type: ComponentValidatorService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { items: [{
                type: Input
            }], label: [{
                type: Input
            }], keyValue: [{
                type: Input
            }], keyLabel: [{
                type: Input
            }] } });

const I18N_VALUES = {
    es: {
        weekdays: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
        months: [
            'Ene',
            'Feb',
            'Mar',
            'Abr',
            'May',
            'Jun',
            'Jul',
            'Ago',
            'Sep',
            'Oct',
            'Nov',
            'Dic',
        ],
    },
};
class I18n {
    constructor() {
        this.language = 'es';
    }
}
I18n.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: I18n, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
I18n.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: I18n });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: I18n, decorators: [{
            type: Injectable
        }] });
class CustomDatepickerI18n extends NgbDatepickerI18n {
    constructor(i18n) {
        super();
        this.i18n = i18n;
    }
    getWeekdayLabel() {
        return '';
    }
    getWeekdayShortName(weekday) {
        return I18N_VALUES[this.i18n.language].weekdays[weekday - 1];
    }
    getMonthShortName(month) {
        return I18N_VALUES[this.i18n.language].months[month - 1];
    }
    getMonthFullName(month) {
        return this.getMonthShortName(month);
    }
    getDayAriaLabel(date) {
        return `${date.day}-${date.month}-${date.year}`;
    }
}
CustomDatepickerI18n.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CustomDatepickerI18n, deps: [{ token: I18n }], target: i0.ɵɵFactoryTarget.Injectable });
CustomDatepickerI18n.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CustomDatepickerI18n });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CustomDatepickerI18n, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: I18n }]; } });

class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '-';
    }
    parse(value) {
        if (value) {
            const dateParts = value.trim().split(this.DELIMITER);
            if (dateParts.length === 1 && this.isNumber(dateParts[0])) {
                return { day: this.toInteger(dateParts[0]), month: null, year: null };
            }
            else if (dateParts.length === 2 &&
                this.isNumber(dateParts[0]) &&
                this.isNumber(dateParts[1])) {
                return {
                    day: this.toInteger(dateParts[0]),
                    month: this.toInteger(dateParts[1]),
                    year: null,
                };
            }
            else if (dateParts.length === 3 &&
                this.isNumber(dateParts[0]) &&
                this.isNumber(dateParts[1]) &&
                this.isNumber(dateParts[2])) {
                return {
                    day: this.toInteger(dateParts[0]),
                    month: this.toInteger(dateParts[1]),
                    year: this.toInteger(dateParts[2]),
                };
            }
        }
        return null;
    }
    format(date) {
        return date
            ? `${this.isNumber(date.day) ? this.padNumber(date.day) : ''}-${this.isNumber(date.month) ? this.padNumber(date.month) : ''}-${date.year}`
            : '';
    }
    toInteger(value) {
        return parseInt(`${value}`, 10);
    }
    isNumber(value) {
        return !isNaN(this.toInteger(value));
    }
    padNumber(value) {
        if (this.isNumber(value)) {
            return `0${value}`.slice(-2);
        }
        else {
            return '';
        }
    }
}
NgbDateCustomParserFormatter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NgbDateCustomParserFormatter, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NgbDateCustomParserFormatter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NgbDateCustomParserFormatter });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: NgbDateCustomParserFormatter, decorators: [{
            type: Injectable
        }] });

class LibDatepickerComponent extends BaseInput {
    constructor(suraFormService, componentValidatorService, changeDetectorRef) {
        super();
        this.suraFormService = suraFormService;
        this.componentValidatorService = componentValidatorService;
        this.changeDetectorRef = changeDetectorRef;
        this.edadMinima = 90;
        this.minDate = { year: 1900, month: 1, day: 1 };
        this.navigation = 'select';
        this.outsideDays = 'visible';
        this.placeholder = 'DD-MM-AAAA';
        this.handleDateSelect = new EventEmitter();
    }
    /* La condición que se agrega en este metodo es debido a que ngbDate agrega por defecto su propio error de fecha y ese
    error se debe mapear para mostrar un mensaje al usuario. */
    showErrorMessage(errors) {
        const keyErrors = Object.keys(errors);
        let keyToSearch = keyErrors[0];
        if (keyErrors.includes(LibDatepickerComponent.NGB_DATE)) {
            keyToSearch = LibDatepickerComponent.INVALID_DATE;
        }
        return this.suraFormService.getErrorMessage(keyToSearch);
    }
    onDateSelect(event) {
        this.handleDateSelect.emit(event);
    }
}
LibDatepickerComponent.NGB_DATE = 'ngbDate';
LibDatepickerComponent.INVALID_DATE = 'INVALID_DATE';
LibDatepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibDatepickerComponent, deps: [{ token: SuraFormService }, { token: ComponentValidatorService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LibDatepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibDatepickerComponent, selector: "lib-datepicker", inputs: { label: "label", edadMinima: "edadMinima", dayTemplate: "dayTemplate", dayTemplateData: "dayTemplateData", footerTemplate: "footerTemplate", displayMonths: "displayMonths", firstDayOfWeek: "firstDayOfWeek", markDisabled: "markDisabled", minDate: "minDate", maxDate: "maxDate", navigation: "navigation", outsideDays: "outsideDays", showWeekdays: "showWeekdays", showWeekNumbers: "showWeekNumbers", startDate: "startDate", placeholder: "placeholder" }, outputs: { handleDateSelect: "handleDateSelect" }, providers: [
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    ], usesInheritance: true, ngImport: i0, template: "<div class=\"mb-3 position-relative\" [class.was-validate]=\"checkControl()\">\n  <div class=\"d-flex align-items-center form-material position-relative\">\n    <input\n      [id]=\"id\"\n      class=\"py-2 px-3 form-material__input\"\n      [formControl]=\"control\"\n      [class.ng-not-empty]=\"control.value\"\n      ngbDatepicker\n      #datepicker=\"ngbDatepicker\"\n      [class.input-not-empty]=\"control.value\"\n      [placeholder]=\"placeholder\"\n      [dayTemplate]=\"dayTemplate\"\n      [dayTemplateData]=\"dayTemplateData\"\n      [displayMonths]=\"displayMonths\"\n      [firstDayOfWeek]=\"firstDayOfWeek\"\n      [footerTemplate]=\"footerTemplate\"\n      [markDisabled]=\"markDisabled\"\n      [maxDate]=\"maxDate\"\n      [minDate]=\"minDate\"\n      [navigation]=\"navigation\"\n      [outsideDays]=\"outsideDays\"\n      [showWeekdays]=\"showWeekdays\"\n      [showWeekNumbers]=\"showWeekNumbers\"\n      [startDate]=\"startDate\"\n      (dateSelect)=\"onDateSelect($event)\"\n      (click)=\"datepicker.open()\"\n    />\n    <label class=\"mx-2 px-2 mb-0 form-material__label\">{{ label }}</label>\n    <i\n      (click)=\"datepicker.toggle()\"\n      class=\"fal fa-calendar-alt position-absolute icon-calendar\"\n    ></i>\n  </div>\n  <div class=\"invalid-message\" *ngIf=\"control.errors\">\n    {{ showErrorMessage(control.errors) }}\n  </div>\n</div>\n", styles: [".icon-calendar{right:.9375rem;font-size:1.25rem;color:var(--color-icon-calendar, #727272);cursor:pointer}.was-validate .icon-calendar{color:#ff585d}.ng-valid~.icon-calendar{color:var(--color-icon-calendar-valid, var(--secondary))}\n", ".form-material{margin-bottom:1.7rem}.form-material__input{width:100%;background:#fff;border:.0625rem solid var(--form-material-input-border-color, #d2d2d2);outline:none;color:#000;font-size:1rem;border-radius:.25rem;font-family:var(--font-family-form-material, var(--font-family-secondary));box-shadow:none;-webkit-appearance:none;-moz-appearance:none}.form-material__input:focus~.form-material__label,.form-material__input.ng-not-empty~.form-material__label{transform:translateY(-1.375rem);font-size:.8125rem}.form-material__input.ng-valid.ng-not-empty{border-color:var(--color-input-valid)!important;color:var(--form-material-text-color-valid, #000)}.form-material__input.ng-valid.ng-not-empty~.form-material__label{color:var(--form-material-valid-label-color, var(--color-input-valid))!important}.form-material__input.ng-valid.ng-not-empty~.form-material__arrow{border-top-color:var(--color-input-valid)}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_success{opacity:1}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_error{opacity:0!important}.form-material__input::-ms-clear{display:none}.form-material__input::-webkit-outer-spin-button,.form-material__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.form-material__arrow{position:absolute;right:.9375rem;pointer-events:none;border-left:.3125rem solid transparent;border-right:.3125rem solid transparent;border-top:.375rem solid #727272}.form-material__label{font-family:var(--font-family-form-label, var(--font-family-secondary));transition:all .15s ease-in-out;font-size:1rem;position:absolute;pointer-events:none;color:var(--form-material-label-color, #999999);background:#fff}.form-material__icon-state{position:absolute;right:.9375rem;font-size:1.375rem;pointer-events:none;opacity:0}.form-material__icon-state_success{color:var(--form-material-color-icon-success, #00aec7)}.form-material__icon-state_error{color:#ff585d}.was-validate .form-material__input{border-color:#e4002b}.was-validate .form-material__label{color:#ff585d}.was-validate .form-material__icon-state_error{opacity:1}.was-validate .form-material__arrow{border-top-color:#ff585d}.was-validate .invalid-message{display:block;text-align:left}.invalid-message{font-weight:100!important;position:absolute;width:100%;margin-top:.25rem;min-height:1.2rem;color:#ff585d;bottom:-1.1rem;font-size:.8rem;display:none}\n"], directives: [{ type: i3$1.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["showWeekdays", "weekdays", "disabled", "autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibDatepickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-datepicker',
                    templateUrl: './lib-datepicker.component.html',
                    styleUrls: ['./lib-datepicker.component.scss', '../../styles/_input.scss'],
                    providers: [
                        I18n,
                        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
                        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: SuraFormService }, { type: ComponentValidatorService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], edadMinima: [{
                type: Input
            }], dayTemplate: [{
                type: Input
            }], dayTemplateData: [{
                type: Input
            }], footerTemplate: [{
                type: Input
            }], displayMonths: [{
                type: Input
            }], firstDayOfWeek: [{
                type: Input
            }], markDisabled: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], navigation: [{
                type: Input
            }], outsideDays: [{
                type: Input
            }], showWeekdays: [{
                type: Input
            }], showWeekNumbers: [{
                type: Input
            }], startDate: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], handleDateSelect: [{
                type: Output
            }] } });

class LibTypeaheadComponent extends BaseInput {
    constructor(suraFormService, componentValidatorService, changeDetectorRef) {
        super();
        this.suraFormService = suraFormService;
        this.componentValidatorService = componentValidatorService;
        this.changeDetectorRef = changeDetectorRef;
        this.itemWithoutAccent = false;
        this.label = 'Seleccione una opción';
        this.keyToShow = 'name';
        this.itemSelected = new EventEmitter();
        this.subscription = new Subscription();
        this.showItemsOnFocus = false;
        this.numberOfItemsToShow = 10;
        this.focus$ = new Subject();
        this.click$ = new Subject();
        this.search = (text$) => {
            const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
            const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
            const inputFocus$ = this.focus$;
            return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => {
                let filterByText = term.length < 2;
                let items = [];
                if (this.showItemsOnFocus) {
                    filterByText = term === '';
                    items = this.items.slice(0, this.numberOfItemsToShow);
                }
                return filterByText
                    ? items
                    : this.items
                        .filter(item => this.itemWithoutAccent
                        ? this.eliminarDiacriticos(item[this.keyToShow])
                            .toLowerCase()
                            .indexOf(term.toLowerCase()) > -1
                        : item[this.keyToShow]
                            .toLowerCase()
                            .indexOf(term.toLowerCase()) > -1)
                        .slice(0, this.numberOfItemsToShow);
            }));
        };
        this.formatter = (item) => item[this.keyToShow];
    }
    ngOnInit() {
        this.subscribeToControl();
    }
    subscribeToControl() {
        this.subscription.add(this.control.valueChanges.subscribe((item) => {
            if (typeof item === 'string') {
                this.checkValidation(item);
            }
        }));
    }
    checkValidation(value) {
        const valor = this.items.filter(item => item[this.keyToShow] === value);
        if (valor[0]) {
            this.control.setValue(valor[0]);
        }
        else {
            this.itemSelected.emit(null);
            this.control.setErrors({ INVALID_TYPEAHEAD: true });
        }
    }
    eliminarDiacriticos(texto) {
        return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    selectItem(event) {
        this.itemSelected.emit(event);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
LibTypeaheadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibTypeaheadComponent, deps: [{ token: SuraFormService }, { token: ComponentValidatorService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
LibTypeaheadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibTypeaheadComponent, selector: "lib-typeahead", inputs: { itemWithoutAccent: "itemWithoutAccent", label: "label", items: "items", keyToShow: "keyToShow", showItemsOnFocus: "showItemsOnFocus", numberOfItemsToShow: "numberOfItemsToShow" }, outputs: { itemSelected: "itemSelected" }, viewQueries: [{ propertyName: "instance", first: true, predicate: ["instance"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"mb-3 position-relative\" [class.was-validate]=\"checkControl()\">\n  <div class=\"d-flex align-items-center form-material position-relative\">\n    <input\n      type=\"text\"\n      class=\"py-2 px-3 form-material__input\"\n      [formControl]=\"control\"\n      [ngbTypeahead]=\"search\"\n      [class.ng-not-empty]=\"control.value\"\n      [id]=\"id\"\n      [editable]=\"true\"\n      (selectItem)=\"selectItem($event)\"\n      [inputFormatter]=\"formatter\"\n      [resultFormatter]=\"formatter\"\n      (focus)=\"showItemsOnFocus && focus$.next($event.target.value)\"\n      (click)=\"showItemsOnFocus && click$.next($event.target.value)\"\n      #instance=\"ngbTypeahead\"\n    />\n    <label class=\"mx-2 px-2 mb-0 form-material__label\">{{ label }}</label>\n    <i\n      class=\"fal fa-check form-material__icon-state form-material__icon-state_success\"\n    ></i>\n    <i\n      class=\"fal fa-times form-material__icon-state form-material__icon-state_error\"\n    ></i>\n  </div>\n  <div class=\"invalid-message\" *ngIf=\"control.errors\">\n    {{ showErrorMessage(control.errors) }}\n  </div>\n</div>\n", styles: [".form-material{margin-bottom:1.7rem}.form-material__input{width:100%;background:#fff;border:.0625rem solid var(--form-material-input-border-color, #d2d2d2);outline:none;color:#000;font-size:1rem;border-radius:.25rem;font-family:var(--font-family-form-material, var(--font-family-secondary));box-shadow:none;-webkit-appearance:none;-moz-appearance:none}.form-material__input:focus~.form-material__label,.form-material__input.ng-not-empty~.form-material__label{transform:translateY(-1.375rem);font-size:.8125rem}.form-material__input.ng-valid.ng-not-empty{border-color:var(--color-input-valid)!important;color:var(--form-material-text-color-valid, #000)}.form-material__input.ng-valid.ng-not-empty~.form-material__label{color:var(--form-material-valid-label-color, var(--color-input-valid))!important}.form-material__input.ng-valid.ng-not-empty~.form-material__arrow{border-top-color:var(--color-input-valid)}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_success{opacity:1}.form-material__input.ng-valid.ng-not-empty~.form-material__icon-state_error{opacity:0!important}.form-material__input::-ms-clear{display:none}.form-material__input::-webkit-outer-spin-button,.form-material__input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.form-material__arrow{position:absolute;right:.9375rem;pointer-events:none;border-left:.3125rem solid transparent;border-right:.3125rem solid transparent;border-top:.375rem solid #727272}.form-material__label{font-family:var(--font-family-form-label, var(--font-family-secondary));transition:all .15s ease-in-out;font-size:1rem;position:absolute;pointer-events:none;color:var(--form-material-label-color, #999999);background:#fff}.form-material__icon-state{position:absolute;right:.9375rem;font-size:1.375rem;pointer-events:none;opacity:0}.form-material__icon-state_success{color:var(--form-material-color-icon-success, #00aec7)}.form-material__icon-state_error{color:#ff585d}.was-validate .form-material__input{border-color:#e4002b}.was-validate .form-material__label{color:#ff585d}.was-validate .form-material__icon-state_error{opacity:1}.was-validate .form-material__arrow{border-top-color:#ff585d}.was-validate .invalid-message{display:block;text-align:left}.invalid-message{font-weight:100!important;position:absolute;width:100%;margin-top:.25rem;min-height:1.2rem;color:#ff585d;bottom:-1.1rem;font-size:.8rem;display:none}\n"], directives: [{ type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3$1.NgbTypeahead, selector: "input[ngbTypeahead]", inputs: ["autocomplete", "placement", "container", "editable", "focusFirst", "showHint", "inputFormatter", "ngbTypeahead", "resultFormatter", "resultTemplate", "popupClass"], outputs: ["selectItem"], exportAs: ["ngbTypeahead"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlDirective, selector: "[formControl]", inputs: ["disabled", "formControl", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibTypeaheadComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-typeahead',
                    templateUrl: './lib-typeahead.component.html',
                    styleUrls: ['../../styles/_input.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: SuraFormService }, { type: ComponentValidatorService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { itemWithoutAccent: [{
                type: Input
            }], label: [{
                type: Input
            }], items: [{
                type: Input
            }], keyToShow: [{
                type: Input
            }], itemSelected: [{
                type: Output
            }], showItemsOnFocus: [{
                type: Input
            }], numberOfItemsToShow: [{
                type: Input
            }], instance: [{
                type: ViewChild,
                args: ['instance', { static: true }]
            }] } });

class LibSwitchComponent {
    constructor() {
        this.toggleSwitch = new EventEmitter();
    }
    toggle() {
        this.toggleSwitch.emit();
    }
}
LibSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibSwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LibSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibSwitchComponent, selector: "lib-switch", inputs: { isActive: "isActive" }, outputs: { toggleSwitch: "toggleSwitch" }, ngImport: i0, template: "<div class=\"switch\">\n  <input type=\"checkbox\" id=\"switch\" class=\"switch__input\" />\n  <label for=\"switch\" class=\"switch__label\" (click)=\"toggle()\">\n    <span\n      class=\"switch__text\"\n      [ngClass]=\"isActive ? 'switch__text_yes' : 'switch__text_no'\"\n      >{{ isActive ? 'Si' : 'No' }}</span\n    >\n  </label>\n</div>\n", styles: [".switch{display:flex}.switch__input{height:0;width:0;visibility:hidden}.switch__input:checked+.switch__label{background-color:#2ac13e}.switch__input:checked+.switch__label:after{left:calc(100% - .3125rem);transform:translate(-100%)}.switch__label{display:flex;align-items:center;cursor:pointer;position:relative;width:3.125rem;height:1.5625rem;background-color:#727272;border-radius:6.25rem;margin-bottom:0}.switch__label:after{content:\"\";position:absolute;top:.2125rem;left:.3125rem;width:1.125rem;height:1.125rem;background-color:#fff;border-radius:5.625rem;transition:.3s}.switch__label:active:after{width:1.875rem}.switch__text{color:#fff;font-size:.9rem}.switch__text_yes{margin-right:auto;margin-left:.625rem}.switch__text_no{margin-left:auto;margin-right:.3125rem}\n"], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibSwitchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-switch',
                    templateUrl: './lib-switch.component.html',
                    styleUrls: ['./lib-switch.component.scss'],
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { isActive: [{
                type: Input
            }], toggleSwitch: [{
                type: Output
            }] } });

class FocusOnErrorDirective {
    constructor(el) {
        this.el = el;
    }
    onFormSubmit() {
        const focusables = ['input', 'select', 'textarea'];
        const invalidInput = this.el.nativeElement.querySelector(focusables.map(x => `${x}.ng-invalid`).join(','));
        if (invalidInput) {
            invalidInput.focus();
        }
    }
}
FocusOnErrorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FocusOnErrorDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FocusOnErrorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: FocusOnErrorDirective, selector: "form", host: { listeners: { "submit": "onFormSubmit()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FocusOnErrorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'form',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { onFormSubmit: [{
                type: HostListener,
                args: ['submit']
            }] } });

/**
 * Modulo que se injecta en el modulo de la aplicación a usar.
 *
 * @args errorMessages: Objeto con los mensajes de error de inputs.
 *
 * imports: [
 *  SuraFormModule.forRoot(
 *      errorMessages
 *   ),
 * ]
 */
class SuraFormModule {
    static forRoot(errorMessages) {
        return {
            ngModule: SuraFormModule,
            providers: [
                {
                    provide: ERROR_MESSAGES,
                    useValue: errorMessages,
                },
            ],
        };
    }
}
SuraFormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SuraFormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormModule, declarations: [TolowercaseDirective,
        DisableCopyPasteDirective,
        LimitNumberDirective,
        LibInputMaterialDesignComponent,
        LibInputSelectMaterialDesignComponent,
        LibDatepickerComponent,
        LibTypeaheadComponent,
        LibSwitchComponent,
        FocusOnErrorDirective], imports: [CommonModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        NgbTypeaheadModule], exports: [TolowercaseDirective,
        DisableCopyPasteDirective,
        LimitNumberDirective,
        LibInputMaterialDesignComponent,
        LibInputSelectMaterialDesignComponent,
        LibDatepickerComponent,
        LibTypeaheadComponent,
        LibSwitchComponent,
        FocusOnErrorDirective] });
SuraFormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormModule, providers: [SuraFormService, ComponentValidatorService], imports: [[
            CommonModule,
            ReactiveFormsModule,
            NgbDatepickerModule,
            NgbTypeaheadModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        NgbDatepickerModule,
                        NgbTypeaheadModule,
                    ],
                    providers: [SuraFormService, ComponentValidatorService],
                    declarations: [
                        TolowercaseDirective,
                        DisableCopyPasteDirective,
                        LimitNumberDirective,
                        LibInputMaterialDesignComponent,
                        LibInputSelectMaterialDesignComponent,
                        LibDatepickerComponent,
                        LibTypeaheadComponent,
                        LibSwitchComponent,
                        FocusOnErrorDirective,
                    ],
                    exports: [
                        TolowercaseDirective,
                        DisableCopyPasteDirective,
                        LimitNumberDirective,
                        LibInputMaterialDesignComponent,
                        LibInputSelectMaterialDesignComponent,
                        LibDatepickerComponent,
                        LibTypeaheadComponent,
                        LibSwitchComponent,
                        FocusOnErrorDirective,
                    ],
                }]
        }] });

const errorMessages = [
    {
        key: 'REQUIRED',
        errorMessage: 'Requerido',
    },
    {
        key: 'INVALID_ONLY_NUMBERS',
        errorMessage: 'Este campo solo permite números',
    },
    {
        key: 'INVALID_PLACA',
        errorMessage: 'La placa digitada es inválida',
    },
    {
        key: 'INVALID_PLACA_AUTOMOVIL',
        errorMessage: 'La placa digitada es inválida',
    },
    {
        key: 'INVALID_ONLY_LETTERS',
        errorMessage: 'Este campo solo permite letras',
    },
    {
        key: 'INVALID_MINIMUN_CHARATERS',
        errorMessage: 'Este campo no cumple con el mínimo de caracteres',
    },
    {
        key: 'minlength MINLENGTH',
        errorMessage: 'Este campo no cumple con el mínimo de caracteres',
    },
    {
        key: 'INVALID_ADDRESS',
        errorMessage: 'Digite una dirección valida',
    },
    {
        key: 'INVALID_EMAIL',
        errorMessage: 'Email inválido',
    },
    {
        key: 'INVALID_EMAIL_UNE',
        errorMessage: 'Correo inválido, por favor ingresa uno diferente a UNE.  ',
    },
    {
        key: 'INVALID_ONLY_CELL_PHONE',
        errorMessage: 'Número de celular inválido',
    },
    {
        key: 'INVALID_MODELO_VEHICULO',
        errorMessage: 'El modelo debe ser menor de 20 años',
    },
    {
        key: 'INVALID_NUMERO_DOCUMENTO',
        errorMessage: 'Digite una cédula de ciudadanía valida',
    },
    {
        key: 'INVALID_CEDULA_EXTRANJERIA',
        errorMessage: 'Digite una cédula de extranjería valida',
    },
    {
        key: 'INVALID_PASAPORTE',
        errorMessage: 'Digite un pasaporte valido',
    },
    {
        key: 'INVALID_MAYOR_DE_EDAD',
        errorMessage: 'La edad mínima es 18 años',
    },
    {
        key: 'INVALID_FECHA_EXPEDICION_CON_FECHA_NACIMIENTO',
        errorMessage: 'Digite una fecha de expedición valida',
    },
    {
        key: 'INVALID_DATE_LESS_TODAY',
        errorMessage: 'La fecha no puede ser superior a hoy',
    },
    {
        key: 'INVALID_NUMBER_PHONE',
        errorMessage: 'Numero de telefono inválido',
    },
    {
        key: 'INVALID_EDAD_MAXIMA',
        errorMessage: 'Supera la edad máxima',
    },
    {
        key: 'INVALID_DATE',
        errorMessage: 'Ingrese una fecha valida',
    },
    {
        key: 'INVALID_TYPEAHEAD',
        errorMessage: 'Seleccione un item de la lista',
    },
];

// Modulo general

/**
 * Generated bundle index. Do not edit.
 */

export { ComponentValidatorService, CustomDatepickerI18n, DisableCopyPasteDirective, ERROR_MESSAGES, FocusOnErrorDirective, I18n, InputProperty, LibDatepickerComponent, LibInputMaterialDesignComponent, LibInputSelectMaterialDesignComponent, LibSwitchComponent, LibTypeaheadComponent, LimitNumberDirective, NgbDateCustomParserFormatter, SuraFormModule, SuraFormService, TolowercaseDirective, errorMessages };
